module.exports = __webpack_public_path__ + "static/media/win3primero.b06d2da3.png";